import { Roles } from "../Data/Users";

export default  {
    items: [
        {
            title: 'Home',
            icon: 'HouseChimney',
            path: '/',
            match: /^\/(work\/.*)?$/,
            notificationBadge: true,
            subitems: [
                {
                        title: 'Dashboard',
                        // icon: 'Truck',
                        path: '/',
                        match: /^\/$/,
                },
                {
                        title: 'Work',
                        // icon: 'Truck',
                        path: '/work',
                        match: /\/work\/*/,
                }
            ]
        },
        // {
        //     title: 'Work',
        //     icon: 'Truck',
        //     path: '/work',
        //     match: /\/work\/*/,
        // },
        {
            title: 'Plan',
            icon: 'CalendarCheck',
            // path: '/plan/calendar',
            match: /^\/plan\/*/,
            role: Roles.Manager,
            subitems: [
                {
                    title: 'Calendar',
                    path: '/plan/calendar',
                    match: /\/plan\/calendar\/*/,
                    feature: 'WEEK_PLANNER',
                    role: Roles.Manager
                },
                {
                    title: 'Rounds',
                    path: '/plan/rounds',
                    match: /\/plan\/rounds\/*/,
                    feature: 'ROUNDS',
                    role: Roles.Manager
                },
                {
                    title: 'Jobs',
                    path: '/plan/jobs',
                    match: /\/plan\/jobs\/*/,
                    role: Roles.Manager
                },
                {
                    title: 'Leads',
                    path: '/plan/leads',
                    match: /\/plan\/leads\/*/,
                    role: Roles.Manager
                },
            ]
        },
        {
            title: 'Manage',
            icon: 'Users',
            // path: '/manage/customers',
            match: /\/manage\/*/,
            role: Roles.Manager,
            subitems: [
                {
                    title: 'Customers',
                    path: '/manage/customers',
                    match: /\/manage\/customers\/*/,
                    feature: 'CUSTOMERS',
                    role: Roles.Manager
                },
                {
                    title: 'Quotes',
                    path: '/manage/quotes',
                    match: /\/manage\/quotes\/*/,
                    role: Roles.Manager
                },
                {
                    title: 'Payments',
                    path: '/manage/payments',
                    match: /\/manage\/payments\/*/,
                    role: Roles.Manager
                },
                // {
                //     title: 'Invoices',
                //     path: '/manage/invoices',
                //     match: /\/manage\/invoices\/*/,
                //     feature: 'CUSTOMERS',
                //     role: Roles.Manager,
                //     adminOnly: true,
                // },
                {
                    title: 'Expenses',
                    path: '/manage/expenses',
                    match: /\/manage\/expenses\/*/,
                    feature: 'EXPENSES',
                    role: Roles.Manager
                },
                // Move to settings ?
                // {
                //     title: 'Reports',
                //     path: '/manage/reports',
                //     match: /\/manage\/reports\/*/,
                // },
            ]
        },
        {
            title: 'More',
            icon: 'LayerGroup',
            path: '/more',
            match: /^\/(more|help|business|user|settings|billing|verification|website|get-social|whats-new|refer-a-friend)\/*/,
            helpMessageBadge: true,
        },
        {
            adminOnly: true,
            title: 'Admin',
            icon: 'Wrench',
            path: '/admin',
            match: /\/admin\/*/,
            subitems: [
                {
                    title: 'Dashboard',
                    path: '/admin',
                    match: /^\/admin$/,
                },
                {
                    title: 'Conversations',
                    path: '/admin/conversations',
                    match: /^\/admin\/conversations$/,
                },
                {
                    title: 'Support Tickets',
                    path: '/admin/support-tickets',
                    match: /^\/admin\/support-tickets$/,
                },
                {
                    title: 'Businesses',
                    path: '/admin/businesses',
                    match: /^\/admin\/businesses$/,
                },
                {
                    title: 'Assistant',
                    path: '/admin/assistant',
                    match: /^\/admin\/assistant$/,
                },
                {
                    title: 'Revenue',
                    path: '/admin/revenue',
                    match: /^\/admin\/revenue$/,
                },
                {
                    title: 'Dial',
                    path: '/admin/dial',
                    match: /^\/admin\/dial$/,
                },
                {
                    title: 'Reports',
                    path: '/admin/reports',
                    match: /^\/admin\/reports$/,
                },
                {
                    title: 'Risk tool accuracy',
                    path: '/admin/risk-tool-accuracy',
                    match: /^\/admin\/risk-tool-accuracy$/,
                },
                {
                    title: 'Fraud risk payments',
                    path: '/admin/fraudulent-risk-payments',
                    match: /^\/admin\/fraudulent-risk-payments$/,
                },
            ],
        }
    ]
}
